<template>
<section class="location-banner">
    <SmoothLoader class="px-4 mt-8 mb-16" v-if="headline">
        <h2 v-html="headline" class="text-center text-white font-medium uppercase tracking-2 text-2xl vt:text-4xl"></h2>
    </SmoothLoader>
    <div class="locations flex">
        <SmoothLoader v-for="(location, i) in locations" :delay="(i * 50) + 100" class="location relative flex items-center justify-center p-4 overflow-hidden">
            <BackgroundImage :src="location.photo.src" :alt="location.photo.alt" opacity="0.9"></BackgroundImage>
            <span class="name block text-center text-sm relative z-20 block text-white font-body font-bold uppercase tracking-2" v-html="location.name"></span>
        </SmoothLoader>
    </div>
</section>
</template>

<script>

import BackgroundImage from '../Utilities/BackgroundImage.vue';
export default {

    props: ['data'],
    
    setup(props) {
        return {
            ...props.data
        }
    },

    components: {
        BackgroundImage
    }

}
</script>